import { Component, Input, OnInit } from '@angular/core';
import { CardPublished } from '../../models/card.model';
import { Group } from '../../models/group.model';

@Component({
  selector: 'app-published-card',
  templateUrl: './published-card.component.html',
  styleUrls: ['./published-card.component.scss']
})
export class PublishedCardComponent implements OnInit {

  @Input() card: CardPublished;
  @Input() group: Group;

  constructor() {}

  ngOnInit() {
    setTimeout(() => {
      this.card.new = false;
    }, 60000)
  }

  cardClicked() {
    this.card.new = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/published-card/published-card.component.ts